// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__hT3IM","delete":"tag_delete__HJFV-","rotate":"tag_rotate__OgLQh"};